import React, { useEffect } from "react";
import { Outlet, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { jwtDecode } from "jwt-decode";
import { setAccessToken,setRefreshToken, getAccessToken, getRefreshToken, clearTokens } from "./utility/interceptors/axiosInstance";
import "./App.css";
import { login } from "./redux/authentication/authActions";
import axios from "axios";
import useDevToolsGuard from "./hooks/useDevToolsGuard";

const App = () => {
  useDevToolsGuard({ enabled: process.env.NODE_ENV === "production" });
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const auth = useSelector((state) => state.auth);

  const refreshTokenApi = async () => {
    const refreshToken = getRefreshToken();
    try {
        const res = await axios.post(
            `${process.env.REACT_APP_API_BASE_URL}:8091/lms/api/client-api/auth/refresh`,
            { refreshToken }
        );

        const accessToken = res.headers['x-access-token'];
        const newRefreshToken = res.headers['x-refresh-token'];

        setAccessToken(accessToken);
        if (newRefreshToken) setRefreshToken(newRefreshToken);
        const { id, fullName, email, username, roles } = res.data; 
        const normalizedRoles = Array.isArray(roles) ? roles : [roles];
         const isAdmin = normalizedRoles.some(role =>["ADMIN", "ADMIN_SUPPORT"].includes(role));
        const currP = isAdmin ? "admin" : "user";

        dispatch(login({ id, fullName, email, username, roles: normalizedRoles, currentPortal: currP  }));

    } catch (err) {
        console.error("Refresh token failed:", err);
        clearTokens();
        navigate("/login");
    }
};

   useEffect(() => {
  const checkToken = async () => {
    const token = getAccessToken();

    if (!token || auth.accessToken) return;

    try {
      const decoded = jwtDecode(token);
      const currentTime = Math.floor(Date.now() / 1000);

      if (decoded.exp < currentTime) {
        await refreshTokenApi();
      } else {
        const { email, roles, fullName, userId } = decoded;
        const username = localStorage.getItem('username');
        const normalizedRoles = Array.isArray(roles) ? roles : [roles];
         const isAdmin = normalizedRoles.some(role =>["ADMIN", "ADMIN_SUPPORT"].includes(role));
        const currP = isAdmin ? "admin" : "user";
        
        dispatch(login({ 
            email, 
            roles: normalizedRoles, 
            accessToken: token, 
            fullName, 
            id: userId, 
            username,
            currentPortal: currP,
        }));
      }
    } catch (err) {
      localStorage.removeItem('username');
      clearTokens();
      navigate("/login");
    }
  };

  checkToken();
}, [auth.accessToken]);

  return (
    <>
      <Outlet />
    </>
  );
};

export default App;
